import { Flex, usePlatformProps } from '@acsbe/ui';
import { isEqual } from 'lodash-es';
import { useTranslation } from 'react-i18next';
// import { trpc } from 'services/api';
import { useEffect, useState } from 'react';
import { useDomainSelection } from '../../../context/DomainSelectionContext';
import { CustomInstallationConfig } from '../../../validations';
import { PageSection } from './common';
import { DEFAULT_WIDGET_CONFIG, useInstallationForm } from './hooks';
import { InstallationForm } from './InstallationForm';
import { WidgetPreview } from './WidgetPreview';
import { formatWidgetConfig } from './widgetSettings';

interface AdvancedInstallationProps {
  style?: React.CSSProperties;
}

export function AdvancedInstallation(props: AdvancedInstallationProps) {
  const { t } = useTranslation('', {
    keyPrefix: 'INSTALLATION_PAGE.ADVANCED_INSTALL',
  });
  const p = usePlatformProps();

  const { widgetSettings, setChangedConfig } = useDomainSelection();
  const [widgetConfig, _setWidgetConfig] =
    useState<CustomInstallationConfig | null>(null);

  const setWidgetConfig = (config: CustomInstallationConfig | null) => {
    _setWidgetConfig(config);
  };

  useEffect(() => {
    _setWidgetConfig(
      widgetSettings
        ? formatWidgetConfig(widgetSettings)
        : DEFAULT_WIDGET_CONFIG,
    );
  }, [widgetSettings]);

  return (
    <PageSection
      title={t('TITLE')}
      minWidth="0px"
      width="100%"
      style={props.style ?? {}}
      setWidgetConfig={setWidgetConfig}
    >
      <Flex
        marginBlockStart={2}
        row
        gap={6}
        {...p.uptoDesktopXs({ row: false, gap: 10 })}
        {...p.fromDesktopXl({ gap: 11.5 })}
      >
        {widgetConfig && (
          <AdvancedInstallationForm
            setChangedConfig={setChangedConfig}
            widgetConfig={widgetConfig}
          />
        )}
      </Flex>
    </PageSection>
  );
}

interface AdvancedInstallationFormProps {
  widgetConfig: CustomInstallationConfig | null;
  setChangedConfig: (config: CustomInstallationConfig | null) => void;
}

function AdvancedInstallationForm({
  widgetConfig,
  setChangedConfig,
}: AdvancedInstallationFormProps) {
  const { t } = useTranslation();
  //@ts-ignore
  const form = useInstallationForm(widgetConfig);
  useEffect(() => {
    if (widgetConfig) {
      form?.reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [widgetConfig]);
  const p = usePlatformProps();

  const changeForm = (data: CustomInstallationConfig) => {
    if (widgetConfig && data && !isEqual(widgetConfig, data)) {
      setChangedConfig(data);
    } else {
      setChangedConfig(null);
    }
  };

  // const customInstallation =
  //   trpc.installation.customizeInstallationScript.useMutation();

  return (
    <>
      <Flex stretch minWidth="0px">
        <InstallationForm
          form={form}
          onSubmit={changeForm}
          notifyOnChange={changeForm}
        >
          {/* <Flex align="start" {...p.uptoDesktopXs({ align: 'center' })}>
            <Button
              type="submit"
              scale="primary"
              variant="primary"
              // disabled={customInstallation.isLoading}
              data-mixpanel="generate-custom-script"
            >
              <span>{t('INSTALLATION_PAGE.ADVANCED_INSTALL.FORM.SUBMIT')}</span>
              <StrokeIcon name="ChevronDown" />
            </Button>
          </Flex> */}
        </InstallationForm>
      </Flex>
      <WidgetPreview control={form.control} />
    </>
  );
}
